import {
  ITransaction,
  TransactionStatus,
  TransactionType,
} from "@/apps/credit-line/models/CreditLineDetails";
import { TransactionReport } from "@/apps/credit-line/models/IReportTransaction";
import { Ref, ref } from "vue";
import { useGetReportTransaction } from "./useGetReportTransaction";

export const useCanReportTransaction = (
  transaction: ITransaction,
  deviceTag: string
): {
  canReportTransaction: Ref<boolean>;
  transactionReport: Ref<null | TransactionReport>;
  checkCanReport: () => Promise<void>;
  isLoad: Ref<boolean>;
  error: Ref<string | null>;
} => {
  const canReportTransaction = ref(false);
  const isLoad = ref(false);
  const { transactionReport, getTransactionReport, error } =
    useGetReportTransaction();
  const validStatusesToReportTransaction = [
    TransactionStatus.PAID,
    TransactionStatus.ACTIVE,
  ];

  const checkCanReport = async (
    transactionParam: ITransaction,
    deviceTagParams: string
  ) => {
    await getTransactionReport(transactionParam, deviceTagParams);

    // If there's an existing report, user cannot report again
    // If there's no report (null) or an error occurred due to no report found, user can report
    const isThereAlreadyAReport = Boolean(transactionReport.value);
    const isTransactionInAValidState =
      validStatusesToReportTransaction.includes(transaction.status);
    const transactionHasValidType =
      transaction.type === TransactionType.CREDITCARD;
    const canReportTransactionResult =
      !isThereAlreadyAReport &&
      isTransactionInAValidState &&
      transactionHasValidType;

    canReportTransaction.value = canReportTransactionResult;
    isLoad.value = true;
  };

  const handleCheckCanReport = async () => {
    if (transaction && deviceTag) {
      await checkCanReport(transaction, deviceTag);
    }
  };

  return {
    canReportTransaction,
    transactionReport,
    checkCanReport: handleCheckCanReport,
    error,
    isLoad,
  };
};
